/** Portail organisateur (liens externes depuis le site vitrine). CRA : REACT_APP_ADMIN_PORTAL_URL */
export const ADMIN_PORTAL_BASE = (
    process.env.REACT_APP_ADMIN_PORTAL_URL || "https://admin.mboapass.com"
).replace(/\/$/, "");
